import { render, staticRenderFns } from "./MailboxesTable.vue?vue&type=template&id=7e567c2f&"
import script from "./MailboxesTable.vue?vue&type=script&lang=js&"
export * from "./MailboxesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e567c2f')) {
      api.createRecord('7e567c2f', component.options)
    } else {
      api.reload('7e567c2f', component.options)
    }
    module.hot.accept("./MailboxesTable.vue?vue&type=template&id=7e567c2f&", function () {
      api.rerender('7e567c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/MailboxesTable.vue"
export default component.exports